import { graphql } from "@opensea/graphql"
import { AccountEnforcementBadgeFragment } from "@/components/trustandsafety/AccountEnforcementBadge.fragment"
import { ProfileAvatarFragment } from "./ProfileAvatar.fragment"
import { ProfileHeaderMetadataChipsFragment } from "./ProfileHeaderMetadataChips.fragment"

export const ProfileInfoFragment = graphql(
  `
    fragment ProfileInfo on Profile {
      address
      imageUrl
      externalUrl
      twitterUsername
      instagramUsername
      isCompromised
      isVerified
      displayName
      ...ProfileAvatar
      ...ProfileHeaderMetadataChips
      ...AccountEnforcementBadge
    }
  `,
  [
    ProfileAvatarFragment,
    ProfileHeaderMetadataChipsFragment,
    AccountEnforcementBadgeFragment,
  ],
)
